import DetailsContainer from "components/TableDetails/components/DetailsContainer";

import { FmxPlatformFiles, FtPlatformFiles } from "./Cards";

const SmartGroupFiles = () => {
    return (
        <DetailsContainer>
            <FtPlatformFiles />
            <FmxPlatformFiles />
        </DetailsContainer>
    );
};

export default SmartGroupFiles;
